import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import { CardProps } from "./Card.types";
import { StyledCard, StyledTrim, TRIM_HEIGHT } from "./Card.styles";
import Box from "../../boxes/Box/Box";

const Card: FC<CardProps> = ({
	className,
	children,
	backgroundColor = "bg_white",
	trim = false,
	interactive = false,
	...props
}) => {
	const block = new BemIt("Card");
	const trimClassName = block.el("trim").out;

	return (
		<StyledCard
			className={addClass(className).after(block)}
			backgroundColor={backgroundColor}
			interactive={interactive}
			{...props}
		>
			{trim && (
				<StyledTrim
					className={trimClassName}
					backgroundColor={backgroundColor}
				/>
			)}
			<Box paddingTop={trim ? TRIM_HEIGHT : "0"}>{children}</Box>
		</StyledCard>
	);
};

export default Card;
